const first_date = new Date('2022-05-15');
export const todays_puzzle = Math.floor((new Date().getTime() - first_date.getTime()) / (1000 * 60 * 60 * 24));
export function load_revealed_words() {
    return get_json_storage('revealed_words', []);
}
export function save_revealed_words(revealed_words) {
    save_to_localStorage('revealed_words', JSON.stringify(revealed_words));
}
export function load_turn_is_guess() {
    return Boolean(localStorage.getItem('turn_is_guess'));
}
export function save_turn_is_guess(turn_is_guess) {
    if (turn_is_guess) {
        save_to_localStorage('turn_is_guess', '1');
    }
    else {
        localStorage.removeItem('turn_is_guess');
    }
}
export function load_completed_puzzles() {
    const completed_puzzles = get_json_storage('completed_puzzles', []);
    if (typeof (completed_puzzles[0]) === 'string') {
        return [];
    }
    else {
        return completed_puzzles;
    }
}
export function save_completed_puzzles(completed_puzzles) {
    save_to_localStorage('completed_puzzles', JSON.stringify(completed_puzzles));
}
export function load_current_puzzle() {
    return get_json_storage('current_puzzle', todays_puzzle);
}
export function save_current_puzzle(current_puzzle) {
    save_to_localStorage('current_puzzle', current_puzzle.toString());
}
function save_to_localStorage(key, value) {
    // TODO error handling for full localStorage
    localStorage.setItem(key, value);
}
function get_json_storage(key, _default) {
    if (localStorage.getItem(key)) {
        return JSON.parse(localStorage.getItem(key));
    }
    else {
        return _default;
    }
}
